export const termsOfUse = window.env.MILESTONES_TERMS_OF_USE_ENDPOINT;
export const privacyPolicy = window.env.MILESTONES_PRIVACY_POLICY_ENDPOINT;
